import { PRODUCT_GROUP_CODES } from '@repo/shared-kit/pricing/constants';

export const LINEUP_PATTERNS = {
  solo: [
    `${PRODUCT_GROUP_CODES.SoloBasic}_`,
    `${PRODUCT_GROUP_CODES.SoloSmart}_`,
    `${PRODUCT_GROUP_CODES.SoloPremium}_`,
  ],
  teams: [
    `${PRODUCT_GROUP_CODES.TeamEnterprise}_`,
    `${PRODUCT_GROUP_CODES.TeamBusiness}_`,
    `${PRODUCT_GROUP_CODES.TeamEssential}_`,
  ],
};
